import { render } from "./ColourPicker.vue?vue&type=template&id=47e42a0e&scoped=true"
import script from "./ColourPicker.vue?vue&type=script&lang=js"
export * from "./ColourPicker.vue?vue&type=script&lang=js"

import "./ColourPicker.vue?vue&type=style&index=0&id=47e42a0e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47e42a0e"]])

export default __exports__